/**
 * Formats a string containing \n to <br>
 *
 * @param {*} value expressions value (result of former chain)
 */
export default (value) => (value ? value.replace(/\n/g, "<br/>") : "");
